/*
 * @Author: Teemo Ding
 * @Date: 2021-08-18 13:42:13
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-03-17 14:04:17
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDetails/RecipientAddressBook/index.tsx
 */
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Collapse } from 'antd';
import _ from 'lodash';
import React, { useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import VisibilityToggle from '@/src/components/VisibilityToggle';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';
import {
  maskConfigFullName,
  maskEmail,
  maskFirstName,
  maskLastName,
  maskPhone,
  maskAddressLine,
} from '@/src/tools/mask';

const RecipientAddressBook = ({ addressBooks, fullNameAutoPopulate }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [show, setShow] = useState(false);

  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={`${css.recipientAddressBook} ${css.wrapperContainer}`}
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>
              {getI18n(
                'customerDatabaseSetting.recipientAddressBook.recipientAddressBook',
              )}
            </span>
            <VisibilityToggle defaultVisible={false} onToggle={setShow} />
          </div>
        }>
        <div>
          <Collapse accordion>
            {(addressBooks || []).map((item, index) => {
              const firstName = _.get(item, 'recipient.firstName', '');
              const lastName = _.get(item, 'recipient.lastName', '');
              const fullName = _.get(item, 'recipient.fullName', '');
              const mobile = _.get(item, 'recipient.mobile', '');
              const email = _.get(item, 'recipient.email', '');
              const addressLine1 = _.get(item, 'deliveryAddress.address1', '');
              const addressLine2 = _.get(item, 'deliveryAddress.address2', '');

              return (
                <Collapse.Panel
                  className={css.customAddress}
                  header={`${getI18n(
                    'customerList.recipientAddressBook.address',
                  )} ${index + 1} ${
                    item.crossBorder
                      ? '(' +
                        _.get(item, 'deliveryAddress.countryRegion', '') +
                        ' Cross-border)'
                      : ''
                  }`}
                  key={index}>
                  <div className={css.informationContainer}>
                    <div className={css.items}>
                      <div className={css.itemsTitle}>
                        {getI18n(
                          'customerDatabaseSetting.recipientAddressBook.recipientInformation',
                        )}
                      </div>
                      {firstName && (
                        <div className={css.item}>
                          <span>
                            {getI18n(
                              'customerList.recipientAddressBook.firstName',
                            )}
                          </span>
                          <span>
                            {show ? firstName : maskFirstName(firstName)}
                          </span>
                        </div>
                      )}
                      {lastName && (
                        <div className={css.item}>
                          <span>
                            {getI18n(
                              'customerList.recipientAddressBook.lastName',
                            )}
                          </span>
                          <span>
                            {show ? lastName : maskLastName(lastName)}
                          </span>
                        </div>
                      )}
                      {fullName && (
                        <div className={css.item}>
                          <span>
                            {getI18n(
                              'customerList.recipientAddressBook.fullName',
                            )}
                          </span>
                          <span>
                            {show
                              ? fullName
                              : maskConfigFullName(
                                  fullName,
                                  fullNameAutoPopulate,
                                )}
                          </span>
                        </div>
                      )}
                      {mobile && (
                        <div className={css.item}>
                          <span>
                            {getI18n(
                              'customerList.recipientAddressBook.mobileNumber',
                            )}
                          </span>
                          <span>
                            {_.get(item, 'recipient.areaCode', '') &&
                              '+' + _.get(item, 'recipient.areaCode', '')}{' '}
                            {show ? mobile : maskPhone(mobile)}
                          </span>
                        </div>
                      )}
                      {email && (
                        <div className={css.item}>
                          <span>{getI18n('general.email')}</span>
                          <span>{show ? email : maskEmail(email)}</span>
                        </div>
                      )}
                    </div>
                    <div className={css.items}>
                      <div className={css.itemsTitle}>
                        {getI18n(
                          'customerDatabaseSetting.recipientAddressBook.deliveryInformation',
                        )}
                      </div>
                      {_.get(item, 'deliveryAddress.countryRegion', '') && (
                        <div className={css.item}>
                          <span>
                            {getI18n(
                              'customerList.recipientAddressBook.country/Region',
                            )}
                          </span>
                          <span>
                            {_.get(item, 'deliveryAddress.countryRegion', '')}
                          </span>
                        </div>
                      )}
                      {addressLine1 && (
                        <div className={css.item}>
                          <span>
                            {getI18n(
                              'customerList.recipientAddressBook.addressLine1',
                            )}
                          </span>
                          <span>
                            {show
                              ? addressLine1
                              : maskAddressLine(addressLine1)}
                          </span>
                        </div>
                      )}
                      {addressLine2 && (
                        <div className={css.item}>
                          <span>
                            {getI18n(
                              'customerList.recipientAddressBook.addressLine2',
                            )}
                          </span>
                          <span>
                            {show
                              ? addressLine2
                              : maskAddressLine(addressLine2)}
                          </span>
                        </div>
                      )}
                      {_.get(item, 'deliveryAddress.city', '') && (
                        <div className={css.item}>
                          <span>
                            {getI18n('customerList.recipientAddressBook.city')}
                          </span>
                          <span>{_.get(item, 'deliveryAddress.city', '')}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </Collapse.Panel>
              );
            })}
          </Collapse>
        </div>
      </SectionWrapper>
    </div>
  );
};

export default RecipientAddressBook;
